var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc16VisibilityOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "m3.757 3.757 8.486 8.486a1 1 0 1 1-1.415 1.414L9.082 11.91c-.35.06-.71.089-1.082.089-2.363 0-4.29-1.188-5.836-3.723L2 8c.413-.716.854-1.331 1.324-1.85l-.98-.978a1 1 0 1 1 1.413-1.415ZM8 4c2.447 0 4.428 1.274 6 4-.413.715-.854 1.33-1.323 1.85l-5.76-5.761C7.267 4.029 7.628 4 8 4Z",
  clipRule: "evenodd"
})));
export default SvgIc16VisibilityOff;